$(function(){
	var catId;
	 var pathname = window.location.pathname;
	if(pathname.split("/")[1] === "luxury"){
		var luxwedurl = "/ajax/luxe/sort.htm";
		}else{
		var luxwedurl = "/ajax/wedding/sort.htm";
		}
    var allStores = $("#all-stores"), $window = $(window), loader = '<div class="loader"></div>',
        sorter = $("#sort-merchants"),
        holder = $(".holder"),
        stats = function(cat, action, label){
            $(document).trigger("stats", {data: ["send", "event", cat, action, label || '']});
            return true;
        },
        sort = function(e, d){
            var selected, cat, type;
            $(this).addClass("selected").siblings("li").removeClass("selected");
            $(this).parent().find(".sort-cat").toggle();
            selected = sorter.find("li.selected"),
            type = selected.text();
            holder.text(type);
			if(catId === "null") {
			    cat = allStores.find("ul").data("cat")
			}
			else{
			    cat = $(".lux-cat-list li").find(".active, .wed-selected.semibold").data("cat")
			}

            allStores.prepend(loader);
            $.get(luxwedurl, {"cat_id": cat, sort: selected.data("value")}).done(function(data){
                allStores.html(data);
                !d && stats("Luxe - All Stores", "Sort", type + " - " + (cat || "All"));
            });
        },
        inView = function (el, threshhold){ // TODO - move it to global ebates object
            var st = $window.scrollTop(), top = el.offset().top, offset = threshhold || 0;
            return top + el.height() < st + $window.height() + offset && top > st - offset;
        };
        sorter.on("click",".sort-cat li", sort);
        sort(true);

    $("body").on("click",".lux-cat-list li .ajax, .lux-subhead", function(){
        allStores.prepend(loader);
        $("li a", $(".lux-cat-list")).removeClass("semibold");
        $(this).addClass('semibold');
        $("li a", $(".lux-cat-list")).addClass("wed-selected");
        console.log("hey");
        $.get(luxwedurl, {"cat_id": $(this).data("cat"), sort: sorter.find("li.selected").data("value")}).done(function(data){
            allStores.html(data);
            stats("Luxe - All Stores", "Category Filter", allStores.find("ul").data("cat") || "All");
        });
        return false;
    });

    stats("Pages", "Luxe", "All Stores");
    //  scroll GA events
    $(".scroll-section").each(function(){
        var $this = $(this), listener = function(){
            inView($this) && stats("Luxe - All Stores", "Section view", $this.attr("data-section")) && $window.off("scroll-throttle", listener);
        };
        $window.on("scroll-throttle", listener);
    });
});
